
export const updatePanoParam = (type, value) => dispatch => {
    dispatch(
        {
            type: type,
            payload : value
        }
    );      
}
